var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("section", { staticClass: "footer" }, [
      _c("footer", [
        _c("div", { staticClass: "footer-main" }, [
          _c("p", { staticClass: "ftlogo" }, [
            _c("a", { attrs: { href: "https://www.lilithgames.com/en" } }, [
              _c("img", { attrs: { src: require("images/logo.png") } }),
            ]),
          ]),
          _c("p", [
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.lilithgames.com/privacy?locale=en-US",
                  target: "_blank",
                  alt: "privacy policy",
                },
              },
              [_vm._v("PRIVACY POLICY")]
            ),
            _c("span", [_vm._v("|")]),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.lilithgames.com/termofservice?locale=en-US",
                  target: "_blank",
                  alt: "Terms of Service",
                },
              },
              [_vm._v("TERMS OF SERVICE")]
            ),
          ]),
          _c("p", [_vm._v("© 2022, LILITH GAMES - ALL RIGHTS RESERVED")]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }